import { CircularProgress, MenuItem } from "@mui/material"

import { Fragment, memo } from "react"
import { useDispatch, useSelector } from 'react-redux'



import CustomDialog from "../../components/layouts/common/CustomDialog"
import { CenteredBox } from "../../components/layouts/OneViewBox"
import { USER_ROLES } from "../../utils/constants"
import AsyncDropDown from "../../components/inputs/AsyncDropDown"
import CustomInput from "../../components/inputs/CustomInputs"



const CreateUi = ({ title, isUpdate, fields, setFields, loading, onSubmit }) => {



    return <>

        <CustomDialog
        id={"Create"}
            loading={loading}
            err={fields.err}
            onSubmit={onSubmit}
            title={`${isUpdate ? "Update" : "Create"} ${title}`}
            closeText="Close"
            confirmText={`${isUpdate ? "Update" : "Create"}`}
        >

            {loading ? <CenteredBox><CircularProgress /></CenteredBox> :
                <>
                    {<CustomInput
                        autoFocus={true}
                        disabled={loading}
                        value={fields.name}
                        onChange={(e) => setFields({ ...fields, err: '', name: e.target.value })}
                        type="text"
                        label={"Patient Name *"}

                    />}
                    {<CustomInput
                        // autoFocus={true}
                        disabled={loading}
                        value={fields.email}
                        onChange={(e) => setFields({ ...fields, err: '', email: e.target.value })}
                        type="text"
                        label={"Email *"}

                    />}
                    {<CustomInput
                        // autoFocus={true}
                        disabled={loading}
                        value={fields.age}
                        onChange={(e) => setFields({ ...fields, err: '', age: e.target.value })}
                        type="number"
                        label={"age *"}

                    />}

                    {<CustomInput
                        // autoFocus={true}
                        disabled={loading}
                        value={fields.phone}
                        onChange={(e) => setFields({ ...fields, err: '', phone: e.target.value })}
                        type="text"
                        label={"Phone *"}

                    />}
                    {<CustomInput
                        // autoFocus={true}
                        disabled={loading}
                        value={fields.password}
                        onChange={(e) => setFields({ ...fields, err: '', password: e.target.value })}
                        type="text"
                        label={"Patient Password *"}

                    />}
                    {<CustomInput
                        // autoFocus={true}
                        disabled={loading}
                        value={fields.address}
                        onChange={(e) => setFields({ ...fields, err: '', address: e.target.value })}
                        type="text"
                        label={"Address *"}

                    />}

                </>}

        </CustomDialog>
    </>
}
export default memo(CreateUi)